import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
const tableHead = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '角色名称'
  },
  dataIndex: 'name',
  align: 'center'
}, {
  slots: {
    title: '状态'
  },
  dataIndex: 'status',
  scopedSlots: {
    customRender: 'status'
  },
  align: 'center'
}, {
  slots: {
    title: '添加时间'
  },
  dataIndex: 'createAt',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center',
  width: 350
}];
import { mapState } from 'vuex';
import standardTable from '@/components/standardTable/index';
import { getRoleTable, deleteRoleTable, roleStatus } from './request';
import { customerResource } from './../../system/customerManage/request';
import roleModel from './roleModel';
export default {
  name: 'roleManage',
  components: {
    standardTable,
    roleModel
  },
  data() {
    return {
      loading: false,
      tableData: [],
      customerList: [],
      currentRow: null,
      dialogVisible: false,
      tableHead,
      form: {
        name: '',
        status: undefined,
        customerId: undefined
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  computed: {
    ...mapState({
      tagList: state => state.tagsView.tagList
    })
  },
  created() {
    customerResource({}).then(res => {
      this.customerList = res;
      let arr = this.customerList.filter(item => item.id == Number(sessionStorage.getItem('customerId')));
      this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('customerId')) : res[0].id;
      // this.form.customerId=res.items[0].id
      // this.form.customerId=Number(sessionStorage.getItem("customerId"))||res.items[0].id
      sessionStorage.setItem('customerId', this.form.customerId);
      this.getRoleTable();
    });
  },
  methods: {
    filterOption(input, option) {
      console.log(option);
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    customerIdFun() {
      sessionStorage.setItem('customerId', Number(this.form.customerId) || '');
    },
    //新增
    handleAdd() {
      this.currentRow = {
        customerId: this.form.customerId
      };
      this.dialogVisible = true;
    },
    getRoleTable() {
      let obj = this.form;
      Object.assign(obj, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      });
      getRoleTable(obj).then(res => {
        this.tableData = res.items || [];
        this.pagination.total = res.totalNum;
      });
    },
    handleEdit(row) {
      this.currentRow = {
        ...row
      };
      this.dialogVisible = true;
    },
    handleOk() {
      this.dialogVisible = false;
      this.currentRow = null;
      this.getRoleTable();
    },
    //删除
    handleDelete(val) {
      let _this = this;
      this.$alert(_this.$t('是否确认删除该角色') + '?', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        deleteRoleTable({
          roleId: val.id
        }).then(() => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getRoleTable();
        });
      });
    },
    checkedFun(val) {
      if (!this.isAuth('home.customerRoleStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      roleStatus({
        roleId: val.id,
        status: val.status == 0 ? 1 : 0
      }).then(res => {
        this.$message.success(this.$t('操作成功') + '!');
        val.status = val.status == 0 ? 1 : 0;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getRoleTable();
    }
  }
};